<template>
    <div class='container'>
        <div class='clause'>
            <!-- <h3 class='text text-center'>托管房屋信息提交</h3> -->
            <hr>

            <div class='trust-forms'>
                <div class='trust-form'>
                    <div class='form-name'>1.所在城市</div>
                    <div class='form-input'>
                        <div class='form-control middle'>
                            {{info.city ? info.city : '请选择'}}
                            <img src='@/assets/datepicker_down_icon@3x.png' class='form-control__icon'/>
                            <select v-model="info.city" disabled>
                                <option value="''" disabled>请选择</option>
                                <option v-for='(city, index) in cities' :key='`city-${index}`' :value='city'>
                                    {{city}}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class='trust-form'>
                    <div class='form-name'>2.详细地址</div>
                    <div class='form-input'>
                        <input type='text' class='form-control' v-model='info.address'/>
                    </div>
                </div>
                <div class='trust-form'>
                    <div class='form-name'>3.房屋面积（平米）</div>
                    <div class='form-input'>
                        <input type='tel' class='form-control' v-model="info.square_meter"/>
                    </div>
                </div>
                <div class='trust-form'>
                    <div class='form-name'>3.称呼</div>
                    <div class='form-input'>
                        <input type='text' class='form-control' v-model='info.username'/>
                    </div>
                </div>
                <div class='trust-form'>
                    <div class='form-name'>4.联系方式</div>
                    <div class='form-input'>
                        <input type='tel' class='form-control' v-model="info.phone"/>
                    </div>
                </div>
            </div>
        </div>

        <div class='submit-form' @click='verify'>提交需求</div>
    </div>
</template>

<script>
    import axios from 'axios'
    import bridge from '@/mixins/bridge'
    const weui = window.weui
    const API_URL = window.location.host == 'clause.zuber.im'
        ? 'https://apiservices.zuber.im'
        : 'http://services.api.zuker.im'

    export default {
        mixins: [bridge],
        data () {
            return {
                cities: ['上海', '北京', '深圳', '广州', '杭州', '南京', '苏州', '成都', '武汉'],
                info: {
                    city: '上海',
                    address: '',
                    square_meter: '',
                    phone: '',
                    username: ''
                }
            }
        },
        methods: {
            hint (context) {
                weui.alert(context)
            },
            verify () {
                if (this.info.city == '') {
                    this.hint('请选择”城市“')
                } else if (this.info.address == '') {
                    this.hint('请填写”详细地址“')
                } else if (this.info.square_meter == '') {
                    this.hint('请填写”房屋面积“')
                } else if (this.info.username == '') {
                    this.hint('请填写”称呼“')
                } else {
                    this.submit()
                }
            },
            submit () {
                const that = this
                const instance = axios.create({
                    baseURL: API_URL
                })
                weui.confirm('确认提交吗？\r\n提交后我们将尽快联系你', () => {
                    const loading = weui.loading('提交中...')
                    instance.post('/client/rooms/decorateapply', this.info).then(() => {
                        loading.hide(() => {
                            weui.toast('提交成功！')
                        })
                        that.postMessage({
                            type: 'success',
                            msg: 'ok'
                        })                        
                    }, () => {
                        loading.hide((res) => {
                            weui.alert(res.result.msg)
                        })
                    })
                })
            }
        }
    }
</script>

